import '@/pages/home/components/Modal/microCMS.css';

import { Box, ModalBody, ModalFooter, Tag } from '@chakra-ui/react';
import React from 'react';

import { CmModal } from '@/components/uiParts';
import { DateDomainService } from '@/domain/services';
import { News } from '@/pages/home/HomePage';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  productInformation: News;
}

export const infoState = {
  function_addition: {
    name: '機能追加',
    bgColor: 'blue.400',
  },
  functional_improvement: {
    name: '機能改善',
    bgColor: 'orange.400',
  },
  information: {
    name: 'お知らせ',
    bgColor: 'green.400',
  },
} as const;

export const ProductInformationDetailModal: React.FC<Props> = ({
  isOpen,
  onClose,
  productInformation,
}) => {
  const { formatCustom } = DateDomainService;
  const { title, publishedAt, info_state, body } = productInformation;
  return (
    <CmModal
      size="3xl"
      isOpen={isOpen}
      isCentered
      onClose={onClose}
      scrollBehavior="inside"
      title="お知らせ更新情報詳細"
    >
      {/*
       // @ts-ignore TS2590 */}
      <ModalBody>
        <>
          <Box fontWeight="bold" textAlign="center">
            {formatCustom(new Date(publishedAt), 'yyyy/MM/dd(E)HH:mm')}
          </Box>
          <Box fontWeight="bold" fontSize="3xl" mt={2} textAlign="center">
            {title}
          </Box>
          {info_state !== '' && (
            <Box textAlign="center" mt={2}>
              <Tag
                rounded="full"
                size="sm"
                variant="solid"
                bgColor={infoState[info_state].bgColor}
                fontWeight="bold"
              >
                {infoState[info_state].name}
              </Tag>
            </Box>
          )}
          <Box
            mt={6}
            fontWeight="bold"
            fontSize="lg"
            borderBottomColor="gray.200"
            borderBottom="1px"
          />
          <Box
            fontWeight="normal"
            dangerouslySetInnerHTML={{ __html: `${body}` }}
            mt={10}
            className="microCMS"
          />
        </>
      </ModalBody>
      <ModalFooter />
    </CmModal>
  );
};
